export default "__VITE_PUBLIC_ASSET__5877af01__"